import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "padding-auth-contents" }
const _hoisted_2 = { class: "pb-4" }
const _hoisted_3 = { class: "text-title-underline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_contact_faq = _resolveComponent("contact-faq")!
  const _component_base_alert = _resolveComponent("base-alert")!
  const _component_contact_form = _resolveComponent("contact-form")!
  const _component_contact_confirm = _resolveComponent("contact-confirm")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_contact_faq)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.t('contact.title')), 1),
              _createVNode(_component_base_alert, { class: "mt-2 mb-4" }),
              (!_ctx.store.state.contact.contactConfirm.on)
                ? (_openBlock(), _createBlock(_component_contact_form, { key: 0 }))
                : _createCommentVNode("", true),
              (_ctx.store.state.contact.contactConfirm.on)
                ? (_openBlock(), _createBlock(_component_contact_confirm, { key: 1 }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}